import React, { useState, useEffect } from 'react';
import { fetchFlightData, getAirline } from './utils';

const FlightTable = ({ data }) => {
    return (
        <div className="flight-table__wrapper">
            <div className="flight-table__header">
                <div>Arriving from</div>
                <div>Airline</div>
                <div>Flight No.</div>
                <div>Scheduled</div>
                <div>Notes</div>
            </div>
            <div className="flight-table__body">
                {data.map((data, index) => (
                    <FlightRow key={index} data={data} />
                ))}
            </div>
        </div>
    );
};

const FlightRow = ({ data }) => {
    console.log(data);
    return (
        <div className="flight-table__row">
            <div>
                <span>Arriving from</span>
                {data.location ?? '-'}
            </div>
            <div>
                <span>Airline</span>
                {getAirline(data.airline) ?? '-'}
            </div>
            <div>
                <span>Flight No</span>
                {data.flightNumber ?? '-'}
            </div>
            <div>
                <span>Scheduled</span>
                {data.time ?? '-'}
            </div>
            <div>
                <span>Notes</span>
                {data.status?.map((status, index) => (
                    <div key={index}>{status}</div>
                ))}
            </div>
        </div>
    );
};

const FlightDisplay = () => {
    const [tab, setTab] = useState(0);
    const [arrivalData, setArrivalData] = useState([]);
    const [departureData, setDepartureData] = useState([]);

    const fetchData = async (file, target) => {
        const data = await fetchFlightData(file);
        if (target === 'arrival') setArrivalData(data);
        if (target === 'departure') setDepartureData(data);
        return data;
    };

    useEffect(() => {
        let aData = fetchData('../../../../../../../data/web_a.ddf', 'arrival');
        let dData = fetchData(
            '../../../../../../../data/web_d.ddf',
            'departure'
        );

        return () => {};
    }, []);

    const handleTabs = (active) => setTab(active);
    const tabContent = [arrivalData, departureData];

    return (
        <>
            <div className="row mb-4 align-items-center">
                <div className="col-sm">
                    <ul className="flights-table__tabs">
                        <li
                            className={tab === 0 ? 'active' : ''}
                            onClick={() => handleTabs(0)}
                        >
                            Arrivals
                        </li>
                        <li
                            className={tab === 1 ? 'active' : ''}
                            onClick={() => handleTabs(1)}
                        >
                            Departures
                        </li>
                    </ul>
                </div>
                {/* <div className="col-sm-auto">
                    <input
                        type="text"
                        placeholder="Search"
                        className="flights-table__search"
                    />
                </div> */}
            </div>
            <div className="row">
                <div className="col">
                    {tabContent.map((c, index) => (
                        <div
                            key={index}
                            className={`flight__content ${
                                tab === index ? 'active' : ''
                            }`}
                        >
                            <FlightTable data={c} />
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default FlightDisplay;
